import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=289deb95&scoped=true&"
import script from "./step1.vue?vue&type=script&lang=js&"
export * from "./step1.vue?vue&type=script&lang=js&"
import style0 from "./step1.vue?vue&type=style&index=0&id=289deb95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289deb95",
  null
  
)

export default component.exports